import { Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ImageService } from '../../../../../../services/images/image.service';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { PersonGenderService } from '../../../../../../services/person-genders/person-gender.service';
import { StudentService } from '../../../../../../services/students/student.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DivisionService } from '../../../../../../services/divisions/division.service';
import { RelationshipService } from '../../../../../../services/relationships/relationship.service';
import { AddStudentDto } from '../../../../../../models/students/dto/AddStudentDto';
import { TutorService } from '../../../../../../services/tutors/tutor.service';
import { Tutor } from '../../../../../../models/tutors/tutor';
import * as moment from 'moment';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';

import { Lightbox } from 'ngx-lightbox';
import { MY_FORMATS } from '../../../../../../const/date-format';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { DocumentationService } from '../../../../../../services/documentations/documentation.service';
import { Observable } from 'rxjs/Observable';
import { DocumentationDto } from '../../../../../../models/documentations/documentation-dto';
import { Student } from '../../../../../../models/students/student';
import { PaymentComponent } from '../payment/payment.component';
import { Payment } from '../../../../../../models/payment/payment';
import { PaymentConceptService } from '../../../../../../services/payment-concept/payment-concept.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { Shift } from '../../../../../../models/shifts/shift';
import { ChangeCourseStudentDto } from '../../../../../../models/students/dto/ChangeCourseStudentDto';
import { Division } from '../../../../../../models/divisions/division';

@Component({
    selector: 'change-course-student',
    templateUrl: './change-course.component.html',
    styleUrls: ['./change-course.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class ChangeCourseStudentComponent implements OnInit, OnDestroy {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    studentFormGroup;

    courseFormControl;
    studentDocNumberFormControl;
    studentLastNameFormControl;
    studentFirstNameFormControl;
    studentBirthdateFormControl;
    studentGenderFormControl;
    studentHasBrothersOfSchoolAgeFormControl;

    markerLngX: number = null;
    markerLatY: number = null;
    confirmDialogRef: any;
    public baseUri;
    public shifts: Shift[] = [];

    minDate = new Date(1930, 0, 1);
    maxDate = new Date();

    viewDivision: boolean  = false;
    // public mask = {
    //     guide: true,
    //     showMask: true,
    //     mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    // };

    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerTutorBirthdate;
    maskedInputControllerStudentBirthdate;

    @ViewChild('tutorBirthdate', {read: ViewContainerRef}) public tutorBirthdate;
    @ViewChild('studentBirthdate', {read: ViewContainerRef}) public studentBirthdate;
    private documentations: any[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ChangeCourseStudentComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private studentService: StudentService,
        private fb: FormBuilder,
        private imageService: ImageService,
        public personGenderService: PersonGenderService,
        private divisionService: DivisionService,
        private relationshipService: RelationshipService,
        private tutorService: TutorService,
        private authenticationService: AuthenticationService,
        private _lightbox: Lightbox,
        public documentationService: DocumentationService,
        public dialog: MatDialog,
        public paymentConceptService: PaymentConceptService,
        private shiftService: ShiftService,
    ) {
        console.log('ChangeCourseComponent > data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        const observables = [];
        observables.push(this.shiftService.getAll());

        Observable.combineLatest(
            observables
        ).subscribe((result) => {
            console.log('result', result);
            this.blockUI.stop();
            
            this.shifts = [...this.shiftService.shifts];
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    loadCourses(shiftId: number) {
        //console.log("SHIFTid" + shiftId);
        this.divisionService.getAllByShiftIdForce(shiftId, this.authenticationService.getAuthData().SchoolYear.Id).subscribe(response => {
            this.blockUI.stop();
            
            if (this.divisionService.divisions.find(e => e.Id === -1) === undefined) {
                const todos = new Division();
                todos.Id = -1;
                todos.DivisionName = 'Seleccione un curso';
                this.divisionService.divisions.unshift(todos);
            }


            console.log('StudentsComponent > ngOnInit > this.divisionService.divisions', this.divisionService.divisions);
            this.viewDivision = true;
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    disable() {
        this.studentFormGroup.get('courseFormControl').disable();
    }

    ngOnDestroy() {
    
    }

    initializeFormControlValidators() {
        this.studentFormGroup = this.fb.group({
            courseFormControl: ['', [Validators.required]],
            studentDocNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
            studentLastNameFormControl: ['', [Validators.required]],
            studentFirstNameFormControl: ['', [Validators.required]],
        });
    }


    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    setMarker($event: any) {
        // console.log('FuseAddStoreComponent > setMarker > $event', $event);
        this.markerLngX = $event.coords.lng;
        this.markerLatY = $event.coords.lat;
    }

    selectAllContent($event) {
        if ($event.target.value === 0) {
            $event.target.select();
        }
    }

    changeCourse() {
        if (this.data.student.DivisionId == -1) {
            this.translationService.translate('ERRORS.ERROR_REQUEST', "No seleccionó un curso", (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
            return;
        }
        this.blockUI.start(this.translationService.savingChanges);

        const changeCourseStudentDto = new ChangeCourseStudentDto();

        changeCourseStudentDto.Id = this.data.student.Id;
        changeCourseStudentDto.DivisionId = this.data.student.DivisionId;
        changeCourseStudentDto.SchoolYearId = this.authenticationService.getAuthData().SchoolYear.Id;

        this.studentService.changeCourse(changeCourseStudentDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                const index = this.studentService.students.findIndex(st => st.Id === this.data.student.Id);
                console.log('valor index', index);
                console.log(this.studentService.students[index]);
                this.studentService.students[index] = this.data.student;
                this.studentService.studentObject[this.data.student.Id] = this.data.student;
                this.dialogRef.close(this.data.student);
                this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.student, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/change-course/change-course.component.ts